<template>
    <div class="nav-bar-content">
        <div class="nav-bar-box">
            <!--左侧logo-->
            <div class="left-logo pointer-cursor" @click="gotoHome">
                <img src="../assets/images/logo.png" />
            </div>

            <!--右侧菜单按钮-->
            <div class="right-menu-list">
                <ul>
                    <li v-for="(item,index) in menuList" :key="index" @click="goPage(item.path)">{{ $t(`index.navBar.${item.title}`) }}</li>
                    <li class="text-right">
                        <el-input v-model="searchValue" placeholder="Search Products" class="search-input" @keydown.enter="onSearchClickHandler">
                            <template #suffix>
                                <el-icon @click="onSearchClickHandler" class="pointer-cursor">
                                    <Search /> <!-- 自定义图标 -->
                                </el-icon>
                            </template>
                        </el-input>
                    </li>
                    <li>
                        <el-switch v-model="isEn" inline-prompt active-text="En" inactive-text="中" @change="onTranslateChange" 
                        :style="{
                            '--el-switch-off-color': primaryColor,
                            '--el-switch-on-color': '#FBBA0E',
                        }"/>
                    </li>
                </ul>

                <div class="phone-menu-icon display-none">
                    <el-dropdown size="large">
                        <el-icon :size="20" class="pointer-cursor border-outline-none" :color="primaryColor">
                            <Menu></Menu>
                        </el-icon>

                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item v-for="(item,index) in menuList" :key="index" @click="goPage(item.path)">{{ $t(`index.navBar.${item.title}`)
                                    }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { UtilMethods } from '@/util/UtilMethods'
import { Search } from '@element-plus/icons-vue'
import { onBeforeMount, ref, Ref } from 'vue'
import { Action, LanguageType, RouterUnion } from '@/typeDefine/CommonTypes'
import { NavMenuType } from '@/typeDefine/EntityType'
import { useI18n } from 'vue-i18n'
import { LanguagePackageType } from '@/typeDefine/EntityType'
import { Translate } from '@/locale/Translate'
import { router, routes } from '@/router'

const {locale} = useI18n<[LanguagePackageType], LanguageType>()

//语言切换标志
const isEn: Ref<boolean> = ref(false)

//获取系统默认色
const primaryColor: string = UtilMethods.getDOMStyleFromCSS('--primary-color')

//菜单项
const menuList: Readonly<Array<NavMenuType>> = [
    {
        title: 'home',
        path: '/'
    },
    {
        title: 'aboutUs',
        path: '/aboutUs'
    },
    {
        title: 'product',
        path: '/products'
    },
    {
        title: 'news',
        path: '/newsList'
    },
    {
        title: 'contactUs',
        path: '/contactUs'
    }
]

//用户搜索内容
const searchValue: Ref<string> = ref('')

onBeforeMount(() => initLanguage())

const gotoHome: Action = () => {
    router.push({
        name: 'index'
    })
}

//触发搜索点击事件
const onSearchClickHandler: Action<[]> = () => {
    router.push({
        name: 'products',
        query: {
            keyword: searchValue.value
        }
    })
}

//初始化获取语言设置
const initLanguage: Action<[]> = () => {
    const language: LanguageType = Translate.instance.getLanguageFromLocal()
    locale.value = language
    isEn.value = language === 'en'
}

//切换语言事件
const onTranslateChange: Action<[boolean]> = (value: boolean) => {
    locale.value = value ? 'en' : 'zh'
    Translate.instance.setLanguage2Local(locale.value)
}

const goPage: Action<[RouterUnion<typeof routes,'path'>]> = (path) => {
    router.push({
        path
    })
}

</script>

<style lang="css" scoped>
.nav-bar-content {
    width: 100%;
    height: 70px;
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, .1);
    background-color: #fff;
}

.nav-bar-content .nav-bar-box {
    display: flex;
    align-items: center;
    height: 100%;
}

.nav-bar-box .left-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
}

.nav-bar-box .left-logo img {
    display: inline-block;
    width: 80%;
}

.nav-bar-box .right-menu-list {
    display: flex;
    align-items: center;
    justify-content: right;
    flex: 1;
    margin: 0 20px;
}

ul,
li {
    list-style: none;
    padding: 0;
    margin: 0;
}

.nav-bar-box .right-menu-list ul {
    display: flex;
    justify-content: right;
    align-items: center;
}

.nav-bar-box .right-menu-list ul li {
    padding: 8px 20px;
    margin: 0 10px;
    cursor: pointer;
    font-size: 18px;
    transition: var(--transition-value);
}

.nav-bar-box .right-menu-list ul li:hover {
    color: var(--primary-color);
}

.right-menu-list .search-input {
    width: 100%;
}

/**响应式 */
@media (max-width: 1260px) {
    .nav-bar-box .right-menu-list ul li {
        font-size: 16px;
        padding: 8px 10px;
    }

    .nav-bar-box .left-logo img {
        width: 200px;
    }
}

@media (max-width: 1000px) {
    .right-menu-list ul li:not(:nth-last-child(-n+2)) {
        display: none;
    }

    .nav-bar-box .left-logo {
        width: 40%;
    }

    .nav-bar-box .left-logo img {
        width: 150px;
        height: 45px;
    }

    .nav-bar-box .right-menu-list {
        margin: 0 5px;
    }

    .phone-menu-icon {
        display: block;
    }
    .nav-bar-box .right-menu-list ul li {
        padding: 4px 5px;
        margin: 0 5px;
    }
}
</style>